import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import { connect } from 'react-redux';
import GeneralForm from '../../components/generalForm';
import { useServiceAreas, useSubscription, useSubscriptionEdit } from './apiHooks';
import utils from '../../utils/utils';
import CustomSelect from '../../components/customFields/customSelect';
import GooglePlacesField from '../../components/customFields/googlePlacesField';
import DateField from '../../components/customFields/dateField';

function AdminSubscriptionForm({ match, history }) {
  const [formSubscription, setFormSubscription] = useState({});
  const { formatMessage } = useIntl();

  const {
    isLoading: loading,
    isError,
    error,
  } = useSubscription(
    {
      subscriptionId: match.params.subscriptionId,
    },
    (subscription) =>
      setFormSubscription({
        ...subscription,
      })
  );

  const {
    editSubscription,
    isLoading: editLoading,
    isError: isEditError,
    error: editError,
  } = useSubscriptionEdit(() =>
    history.push({
      pathname: '/admin/subscriptions',
    })
  );

  const { serviceAreas } = useServiceAreas();

  const serviceAreaOptions = serviceAreas
    ? serviceAreas.map((area) => {
        return {
          value: area.id,
          label: `${area.name}`,
        };
      })
    : [];

  const formSchema = {
    type: 'object',
    required: [],
    properties: {
      frequency: {
        title: formatMessage({ id: 'subscription.form.field.frequency.label' }),
        type: 'string',
        default: '',
        options: [
          {
            value: 'WEEKLY',
            label: `WEEKLY`,
          },
          {
            value: 'BI_WEEKLY',
            label: `BI_WEEKLY`,
          },
        ],
      },
      deliveryDay: {
        title: formatMessage({ id: 'subscription.form.field.delivery.day.label' }),
        type: 'string',
        default: '',
        options: [
          {
            value: 'MONDAY',
            label: `MONDAY`,
          },
          {
            value: 'FRIDAY',
            label: `FRIDAY`,
          },
        ],
      },
      timeRange: {
        title: formatMessage({ id: 'subscription.form.field.time.range.label' }),
        type: 'string',
        default: '',
      },
      nextDeliveryDate: {
        type: 'string',
        title: formatMessage({ id: 'subscription.form.field.next.delivery.date.label' }),
      },
      active: {
        type: 'boolean',
        title: formatMessage({ id: 'subscription.form.field.active.label' }),
      },
      address: {
        showCustomerFields: true,
        noMarginTop: true,
        type: 'object',
        required: [],
        properties: {
          serviceAreaId: {
            type: 'string',
            options: serviceAreaOptions,
          },
          unit: {
            type: 'string',
            default: '',
          },
          street: {
            type: 'string',
            default: '',
          },
          city: {
            type: 'string',
            default: '',
          },
          country: {
            type: 'string',
            default: '',
          },
          postCode: {
            type: 'string',
            default: '',
          },
          coordinates: {
            type: 'object',
            required: [],
            properties: {
              lat: {
                type: 'string',
              },
              lon: {
                type: 'string',
              },
            },
          },
        },
      },
    },
  };

  const uiSchema = {
    deliveryDay: {
      'ui:field': 'customSelect',
    },
    frequency: {
      'ui:field': 'customSelect',
    },
    address: {
      'ui:field': 'googlePlacesField',
    },
    nextDeliveryDate: {
      'ui:field': 'dateField',
    },
    active: {
      'ui:help': formatMessage({id: 'subscription.form.field.active.help'}),
    },
  };

  const onFormSubmit = () => {
    try {
      editSubscription({ subscription: formSubscription });
    } catch (e) {
      window.scrollTo(0, 0);
    }
  };

  const formFields = {
    dateField: DateField,
    customSelect: CustomSelect,
    googlePlacesField: GooglePlacesField,
  };

  const buttonCopy = 'subscription.form.cta.edit';

  return (
    <div className="row m-b-6">
      <div>
        <div className="col-12 col-lg-10 offset-lg-1 admin__form">
          <GeneralForm
            title={formatMessage({ id: 'subscription.form.title' })}
            onChange={(event) => setFormSubscription(event.formData)}
            onSubmit={onFormSubmit}
            formSchema={formSchema}
            formUiSchema={uiSchema}
            formFields={formFields}
            formData={formSubscription}
            buttonCopy={buttonCopy}
            errorMessage={isError || isEditError ? utils.getErrorMessageFromResponse(error || editError, true) : null}
            loading={loading || editLoading}
            hideImageUpload={true}
          />
        </div>
      </div>
    </div>
  );
}

function mapStateToProps(state) {
  return {
    currentUser: state.currentUser.user,
  };
}

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(AdminSubscriptionForm);
